var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.048 9.3155L21.0619 0H19.1629L12.2044 8.08852L6.64672 0H0.236572L8.64091 12.2313L0.236572 22H2.13572L9.48403 13.4583L15.3534 22H21.7635L13.0476 9.3155H13.048ZM10.4469 12.339L9.59536 11.1211L2.82 1.42964H5.73698L11.2048 9.25094L12.0563 10.4689L19.1638 20.6354H16.2468L10.4469 12.3395V12.339Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ef3b9c06dd6662aa8cb19cd669153170.svg";
export { ForwardRef as ReactComponent };